import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Homepage from "./Pages/Home/Homepage";
import StrongHabit from "./Pages/StrongHabit/StrongHabit";

const App: React.FC = () => (
  <HelmetProvider>
    <BrowserRouter>
      <div className="min-h-screen w-full font-sans transition-colors duration-300">
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/strong-habit/*" element={<StrongHabit />} />
        </Routes>
      </div>
    </BrowserRouter>
  </HelmetProvider>
);

export default App;
